export const homeObjOne = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: '',
    headline: 'About Us',
    description:
      'Our People are our greatest assest and the Biggest Differentiator we are a group of Tech Enthusiasts who are passionate about technology and love to learn new things.',
    buttonLabel: 'Scroll Down',
    imgStart: '',
    img: require('../../images/team.png'),
    alt: 'Credit Card',
    start: ''
  };